module.exports = __webpack_public_path__ + "static/media/carrierOverview.c0b238ff.png";